<template>
  <div class="modal-body" v-if="currentTraining != null">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-body">
            <div class="box-group" id="accordion">
              <div class="panel box box-primary">
                <div class="box-header with-border">
                  <h4 class="box-title">
                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseHelp" aria-expanded="false"
                       class="collapsed">
                      {{$t('help.title')}}
                    </a>
                  </h4>
                </div>
                <div id="collapseHelp" class="panel-collapse collapse" aria-expanded="false"
                     style="height: 0px;">
                  <div v-if="$root.$i18n.locale == 'en'" class="box-body">
                    <p>If accommodation is not included in the price of the program and has to be paid for by the
                      participant separately (if he/she prefers it at all), - please, type here such accommodation
                      option (-s) and its respective price.</p>

                    <p><b>Example (a)</b>.<br> <i>Option 1:</i> Hotel “Diamond” (5*), single room (half board) -
                      350 USD.
                      <br>
                      <i>Option 2:</i> Hotel “Diamond” (5*), twin room (half board) - 250 USD.</p>

                    <p><b>Example (b)</b>.<br> <i>Option 1:</i> Hotel “Diamond” (5*), single room for an athlete
                      (half board) - 350 USD.
                      <br>
                      <i>Option 2:</i> Hotel “Diamond” (5*), single room for a guest (half board) - 400 USD.</p>

                  </div>
                  <div v-if="$root.$i18n.locale == 'ru'" class="box-body">
                    <p>Если стоимость Проживания не включена в цену программы, и должна оплачиваться спортсменом
                      отдельно, - то укажите варианты проживания и цену (-ы) за весь период проживания.</p>

                    <p><b>Пример а)</b><br> <i>Вариант 1:</i> Гостиница “DIamond” (5*), одноместный номер
                      (завтраки); Цена - 13 000 руб;
                      <br>
                      <i>Вариант 2:</i> Гостиница “DIamond” (5*), двухместный номер (завтраки); Цена - 9 000 руб.
                    </p>

                    <p><b>Пример б)</b><br> <i>Вариант 1:</i> Гостиница “DIamond” (5*), одноместный номер для
                      спортсмена (завтраки); Цена - 13 000 руб;
                      <br>
                      <i>Вариант 2:</i> Гостиница “DIamond” (5*), одноместный номер для сопровождающего
                      (завтраки); Цена -14 000 руб.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.residences.active-residences')}}</h3>
          </div>
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <tbody>
              <tr>
                <th>{{$t('trainings.residences.name')}}</th>
                <th v-if="isBackoffice()">{{$t('trainings.residences.name')}} [ru]</th>
                <th>{{$t('trainings.residences.price')}}</th>
                <th></th>
              </tr>
              <tr
                v-for="residence in currentTraining.residences"
                :key="residence.id">
                <td v-if="!isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="residence.name[$root.$i18n.locale]" class="form-control">

                    <span class="input-group-btn">
                      <button v-on:click="updateResidence(residence)" type="button" class="btn btn-info btn-flat">Save</button>
                    </span>
                  </div>
                </td>
                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="residence.name['en']" class="form-control">

                    <span class="input-group-btn">
                      <button v-on:click="updateResidence(residence)" type="button" class="btn btn-info btn-flat">Save</button>
                    </span>
                  </div>
                </td>
                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="residence.name['ru']" class="form-control">

                    <span class="input-group-btn">
                        <button v-on:click="updateResidence(residence)" type="button" class="btn btn-info btn-flat">Save</button>
                      </span>
                  </div>
                </td>
                <td>{{residence.price.value}} {{residence.price.currency.codeISO}}</td>
                <td><a v-on:click="deleteResidence(residence.id)"><i
                  class="text-red fa fa-times-circle-o"></i></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.residences.added-form.title')}}</h3>
          </div>
          <div class="box-body">
            <div v-if="!isBackoffice()" class="form-group">
              <label>{{$t('trainings.residences.added-form.name')}}</label>
              <input type="text" v-model="addedResidence.name[$root.$i18n.locale]" class="form-control"
                     placeholder="">
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.residences.added-form.name')}} [en]</label>
              <input type="text" v-model="addedResidence.name['en']" class="form-control"
                     placeholder="">
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.residences.added-form.name')}} [ru]</label>
              <input type="text" v-model="addedResidence.name['ru']" class="form-control"
                     placeholder="">
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label>{{$t('trainings.residences.added-form.price')}}</label>
                    <input type="text" class="form-control" v-model="addedResidence.price.value" placeholder="">
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group">
                    <label>{{$t('trainings.residences.added-form.currency')}}</label>
                    <select name="currency" class="form-control" v-model="addedResidence.price.currency">
                      <option value="RUB">RUB</option>
                      <option value="EUR">EUR</option>
                      <option value="USD">USD</option>
                      <option value="GBP">GBP</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <button type="submit" v-on:click="saveResidence" class="btn btn-info pull-right">
              {{$t('button.save-changes')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TrainingResidences',
  props: {
    currentTraining: Object
  },
  data () {
    return {
      addedResidence: {
        trainingId: '',
        name: {
          ru: '',
          en: ''
        },
        price: {
          value: 0,
          currency: ''
        },
        description: {
          ru: '',
          en: ''
        }
      }
    };
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    deleteResidence (residenceId) {
      var del = {
        residenceId: residenceId,
        trainingId: this.currentTraining.id
      };

      var self = this;

      console.log(del);

      axios.delete(
        window.host + '/trainings/' + self.currentTraining.id + '/residences/' + residenceId, del)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', del.trainingId);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    saveResidence () {
      var self = this;

      self.addedResidence.trainingId = self.currentTraining.id;

      axios.put(
        window.host + '/trainings/' + self.currentTraining.id + '/residences', self.addedResidence)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.addedResidence.trainingId);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    updateResidence (residence) {
      var self = this;

      residence.trainingId = self.currentTraining.id;

      var savedResidence = {
        residenceId: residence.id,
        trainingId: self.currentTraining.id,
        price: {
          value: residence.price.value,
          currency: residence.price.currency.codeISO
        },
        name: residence.name,
        description: residence.description,
      };

      axios.put(
        window.host + '/trainings/' + self.currentTraining.id + '/residence/update', savedResidence)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>

</style>
